(function () {
    var subscribe = MW.events.subscribe;
    var publish = MW.events.publish;

    // options == {callback: function(){}, subscription: "whatever"}
    function enqueue(options) {
        var queue = [],
            queueLoaded = {};

        queueLoaded[options.subscription] = true;

        subscribe(options.subscription, function () {
            queue.forEach(function (args) {
                setTimeout(function () {
                    options.callback.apply(null, args);
                }, 0);
            });
            queue = [];
        });
        return function () {
            var args = arguments;

            if (queueLoaded[options.subscription]) {
                setTimeout(function () {
                    options.callback.apply(null, args);
                }, 0);
            } else {
                queue.push(args);
            }
        };
    }

    var comscore = enqueue({
        subscription: "tracking_loaded_comscore",
        callback: function (payload) {
            if (window.COMSCORE) {
                COMSCORE.beacon(payload);
            }
        },
    });

    var rapidBeaconPageview = enqueue({
        subscription: 'tracking_loaded_rapid',
        callback: function (payload) {
            if (window.RapidInstance) {
                window.RapidInstance.beaconPageview(payload);
            }
        }
    });

    var rapidBeaconEvent = enqueue({
        subscription: 'tracking_loaded_rapid',
        callback: function (payload, outcome) {
            if (window.RapidInstance) {
                window.RapidInstance.beaconEvent('simple', payload, outcome);
            }
        }
    });

    // add PV to every 5th slide, must pass container
    // an modal slideshow can only have 1 slideshow, there can be multiple inline listicles though
    var addSlidePVs = function ($container, modalSlideshow) {
        if (modalSlideshow) {
            addSlidePVsSpecific($container, modalSlideshow);
        } else {
            var $listicles = $container.find('.listicle');
            $listicles.each(function (ind, listicle) {
                addSlidePVsSpecific($(listicle), modalSlideshow);
            });

            $(window).trigger('checkInView');
        }
    };

    // Helper function to add PV to every 5th slide of a singular slideshow
    // Use waypoints inview js to track if slide is in view
    var addSlidePVsSpecific = function ($container, modalSlideshow) {
        var selector = '.listicle__slide';
        // for inline listicles we want to PV on slides 5, 10, 15, etc.
        // for modal slidehows we want to PV on slides 1, 6, 11, 16, etc.
        var listicleOffset = modalSlideshow ? 0 : 1;
        var $parent = $container;

        setTimeout(function() {
            $container.find(selector).addBack(selector).each(function(ind, el) {
                if ((ind+listicleOffset) % 5 === 0) {
                    var $el = $(el);
                    var context;

                    if (modalSlideshow) {
                        context = $container.find('.modal__content')[0];
                    } else {
                        context = $container.closest('.modal__content')[0];
                    }

                    var inview = new Waypoint.Inview({
                        element: el,
                        context: context,
                        enter: function() {
                            if (!$el.data('tracky-slide-pv-viewed')) {
                                $el.attr('data-tracky-slide-pv-viewed', true);

                                var options = {
                                    type: modalSlideshow ? 'slideshow' : 'slides_list',
                                    sub_type: 'gallery',
                                    slideshow_id: $parent.data('id'),
                                    id: $el.data('id'),
                                    pos: parseInt($el.data('index')) + 1,
                                    length: $parent.data('length'),
                                    credit: $el.data('credit'),
                                    slide_type: $el.data('type'),
                                    slide_filename: $el.attr('data-sharingimage'),
                                };
                                publish('tracking_slide_pv', options);
                            }
                        }
                    });
                }
            });
        }, 500);
    };

    subscribe("tracking_slide_pv", function (options) {
        publish("tracking_fire_pv", {
            comscore: window.comscore_data,
            rapidCustom: {
                _R: Mobileweb.params.original_url,
                expn: 'slideshow',
                navtype: 'client'
            },
            buzzfeedCet: {
                data: {
                    context_page_type: "buzz_gallery"
                }
            }
        });
    });

    // Holding back on spelling it "Tracquix"
    MW.modules.Tracky = {
        comscore: comscore,
        addSlidePVs: addSlidePVs,
        rapidBeaconPageview: rapidBeaconPageview,
        rapidBeaconEvent: rapidBeaconEvent,
    };

    subscribe("entered_entry", function ($entry) {
        var trackingData = $entry.attr("data-tracking-data");
        var tracking = $entry.attr("data-tracking");
        if (trackingData) {
            MW.elements.$trackingData.html(trackingData);
        }
        if (tracking) {
            MW.elements.$tracking.html(tracking);
            $entry.attr("data-tracking", null);
        }
    });

    subscribe("read_more", function () {
        rapidBeaconPageview({
            _R: Mobileweb.params.original_url,
            expn: 'readmore-content',
            navtype: 'client',
        });
        buzzfeedCetPageview({
            data: {
                context_page_type: "buzz_read_more"
            }
        });

    });

    subscribe("tracking_ping", function (payload) {
        rapidBeaconEvent(payload.data, payload.name);
    });

    subscribe("end_of_entry", function () {
        rapidBeaconEvent(null, 'end_of_entry');
    });

    subscribe('comments_opened', function () {
        rapidBeaconPageview({
            pct: 'comments',
            expn: 'comments',
            navtype: 'client'
        });
        buzzfeedCetPageview({
            data: {
                context_page_type: "buzz_comments"
            }
        });
    });

    subscribe('highlighted_text', function(text) {
        rapidBeaconEvent({text: text}, 'highlighted_text');
    });

    // More macro-y stuff
    subscribe("tracking_fire_pv", function (payload) {
        comscore(payload.comscore);

        if (payload.rapidCustom) {
            rapidBeaconPageview(payload.rapidCustom);
        }
        buzzfeedCetPageview(payload.buzzfeedCet);

    });

    subscribe("infinite_scroll", function () {
        rapidBeaconEvent(
            {
                expn: 'infinite-scroll',
                navtype: 'client'
            },
            'aol_comscore_pv'
        );
    });

}());
